import type { SubsSection, SubRowVariant } from '@/msgdeskRuntime/state'

type MenuMode = 'drafts' | 'trash' | 'favs'

export function mainTemplateVariant(_section: SubsSection): SubRowVariant {
  // Notes rows always use the note-card interaction contract. Persisted
  // section Display values remain stored for compatibility, but Chat (the
  // only variant with nested disclosure controls) must not replace the
  // click-to-preview card on this surface.
  return 'comments'
}

export function menuTemplateVariant(_mode: MenuMode, _section: SubsSection): SubRowVariant {
  // Folder pages share the neutral 'folder' row (deskUi/rowTemplates/FolderRow).
  return 'folder'
}

export function nestedTemplateVariant(): SubRowVariant {
  return 'auto'
}
